module.exports = __webpack_public_path__ + "img/IMG_3687.db78a8ba.jpg";